// extracted by mini-css-extract-plugin
export default {"loading":"_2DEhD"};